module.exports = __webpack_public_path__ + "static/media/PricingWorkspaceStep4.2538669f.jpg";